import * as _ from "lodash";
import { v4 as uuidv4 } from 'uuid';
import { USER_DATA, ACCESS_TOKEN_WEB, REFRESH_TOKEN_WEB } from "../consts";
import moment from "moment";
import Swal from "sweetalert2";
import i18nInstance from "../i18n";

// ===== WebView Detection =====
export function isInAppBrowser() {
  const ua = navigator.userAgent || navigator.vendor || '';
  return /FBAN|FBAV|Instagram|Line\/|Twitter|MicroMessenger|Snapchat/i.test(ua);
}

// ===== Safe Clipboard Copy (WebView compatible) =====
export async function safeClipboardCopy(text) {
  try {
    if (navigator.clipboard && navigator.clipboard.writeText) {
      await navigator.clipboard.writeText(text);
      return true;
    }
  } catch (e) {
    // clipboard API blocked in WebView
  }
  // Fallback: document.execCommand('copy')
  try {
    const textarea = document.createElement('textarea');
    textarea.value = text;
    textarea.style.position = 'fixed';
    textarea.style.left = '-9999px';
    textarea.style.top = '-9999px';
    document.body.appendChild(textarea);
    textarea.focus();
    textarea.select();
    document.execCommand('copy');
    document.body.removeChild(textarea);
    return true;
  } catch (e) {
    return false;
  }
}

// ===== Device ID for Login One Device =====
export function getDeviceId() {
  try {
    let deviceId = localStorage.getItem('device_id');
    if (!deviceId) {
      deviceId = uuidv4();
      localStorage.setItem('device_id', deviceId);
    }
    return deviceId;
  } catch (e) {
    // localStorage blocked in iOS WebView private mode
    return uuidv4();
  }
}

// get user data from localStorage
export const getUserDataFromLCStorage = () => {
  try {
    const raw = localStorage.getItem(USER_DATA);
    if (raw && raw !== "undefined" && raw !== "null") {
      return JSON.parse(raw);
    }
  } catch (e) {
    console.warn("Invalid user data in localStorage, clearing...");
    localStorage.removeItem(USER_DATA);
  }
  return null;
};

export const getAccessTokkenFromLCS = () => {
  try {
    const raw = localStorage.getItem(ACCESS_TOKEN_WEB);
    if (raw && raw !== "undefined" && raw !== "null") {
      const _tokken = JSON.parse(raw);
      return _tokken ? `Bearer ${_tokken}` : undefined;
    }
  } catch (e) {
    console.warn("Invalid access token in localStorage, clearing...");
    localStorage.removeItem(ACCESS_TOKEN_WEB);
  }
  return undefined;
};

export const getRefreshTokenFromLCS = () => {
  try {
    const raw = localStorage.getItem(REFRESH_TOKEN_WEB);
    if (raw && raw !== "undefined" && raw !== "null") {
      return JSON.parse(raw);
    }
  } catch (e) {
    localStorage.removeItem(REFRESH_TOKEN_WEB);
  }
  return null;
};

export const useAuth = () => {
  const userData = getUserDataFromLCStorage();
  const token = getAccessTokkenFromLCS();
  // ต้องมีทั้ง user data และ access token ถึงจะถือว่า login แล้ว
  // (กันกรณีมี user data ค้างอยู่ แต่ token หาย → ถือว่ายังไม่ login)
  const isAuthenticated = !_.isEmpty(userData) && !!token;
  return isAuthenticated;
};

export const ClearUserDataFormLCStorage = () => {
  localStorage.removeItem(USER_DATA);
  localStorage.removeItem(ACCESS_TOKEN_WEB);
  localStorage.removeItem(REFRESH_TOKEN_WEB);
};
export const formatCurrency = (int) => {
  const formatter = new Intl.NumberFormat("en-US");
  return formatter.format(int);
};
export const toDayDash = (item) => {
  // moment.locale("lo");
  let resp = moment(item).format("DD/MM/YYYY");
  if (item) return resp;
  else return "-";
};
export const toDateTime = (item) => {
  // moment.locale("lo");
  let resp = moment(item).format("DD-MM-YYYY, hh:mm:ss");
  if (item) return resp;
  else return "-";
};
export let convertStatus = (status) => {
  let resp = "";
  switch (status) {
    case "SUCCESS":
      resp = <span style={{ color: "green" }}>{i18nInstance.t("HelperStatusSuccess")}</span>;
      break;
    case "WAITING":
      resp = <span style={{ color: "orange" }}>{i18nInstance.t("HelperStatusProcessing")}</span>;
      break;
    case "CANCEL":
      resp = <span style={{ color: "red" }}>{i18nInstance.t("HelperStatusCancelled")}</span>;
      break;
    case "APPROVED":
      resp = <span style={{ color: "green" }}>{i18nInstance.t("HelperStatusSuccess")}</span>;
      break;

    default:
      break;
  }
  return resp;
};
export const convertStatusMoney = (status) => {
  let resp = "";
  switch (status) {
    case "WAITING":
      resp = i18nInstance.t("HelperStatusProcessing");
      break;
    case "CANCEL":
      resp = i18nInstance.t("HelperStatusCancelled");
      break;
    case "SUCCESS":
      resp = i18nInstance.t("HelperStatusSuccess");
      break;

    default:
      break;
  }
  return resp;
};
export const SelectPhoneForCopy = async (e, code) => {
  e.stopPropagation();
  await safeClipboardCopy(code);
  Swal.fire({
    icon: "success",
    title: i18nInstance.t("HelperCopySuccess"),
  });
  return;
};
export let fetchDataFromDatabase = (dataTime) => {
  let now = new Date();
  let currentTime =
    (now.getHours() < 10 ? "0" : "") +
    now.getHours() +
    ":" +
    (now.getMinutes() < 10 ? "0" : "") +
    now.getMinutes();
  if (
    currentTime >= dataTime?.split("-")[0] &&
    currentTime <= dataTime?.split("-")[1]
  ) {
    return "";
  } else {
    return "none";
  }
};
// get user data from localStorage
export const SetLanguage = (data) => {
  localStorage.setItem("Language", JSON.stringify(data));
};
